module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-uploader-wrapper"
  }, [(_vm.image) ? _c('div', {
    staticClass: "img",
    style: ({
      backgroundImage: 'url(' + _vm.image + ')'
    })
  }) : _c('div', {
    staticClass: "img default"
  }), _vm._v(" "), _c('el-button', {
    staticClass: "media-btn",
    on: {
      "click": _vm.openMediaImageDialog
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "hint"
  }, [_vm._v(_vm._s(_vm.title || _vm.$t('actions.imageUploader.defaultCoverHint')))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50b684f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/image_uploader.vue
// module id = 920
// module chunks = 3